import { Store } from "vuex";
import { RootState } from "./types";
import { useStore as baseUseStore } from "vuex";

export const useStore = (): Store<RootState> => {
  return baseUseStore<RootState>();
};
